import { Provider } from 'app/KinerjaTimPenilaiPSPage/components/Penetapan/TablePenetapan/Provider'
import { ActionBulkPenetapan } from 'app/KinerjaTimPenilaiPSPage/components/Penetapan/TablePenetapan/ActionBulkPenetapan'
import { Pagination } from 'app/KinerjaTimPenilaiPSPage/components/Penetapan/TablePenetapan/Pagination'
import { Table } from 'app/KinerjaTimPenilaiPSPage/components/Penetapan/TablePenetapan/Table'
import { TableSendToEkin } from 'app/KinerjaTimPenilaiPSPage/components/Penetapan/TablePenetapan/TableSendToEkin'
import { Toolbar } from 'app/KinerjaTimPenilaiPSPage/components/Penetapan/TablePenetapan/Toolbar'
import { ActionBulkSendToPPK } from 'app/KinerjaTimPenilaiPSPage/components/Penetapan/TablePenetapan/ActionBulkSendToPPK'
import { ActionBulkSendToEkin } from 'app/KinerjaTimPenilaiPSPage/components/Penetapan/TablePenetapan/ActionBulkSendToEkin'

export const TablePenetapan = {
  ActionBulkPenetapan,
  ActionBulkSendToPPK,
  ActionBulkSendToEkin,
  Pagination,
  Provider,
  Table,
  TableSendToEkin,
  Toolbar,
}
